module.exports = "<div class=\"users-module\" flex layout-fill>\n  <div lang></div>\n  <ui-view flex layout-fill></ui-view>\n</div>\n\n<div class=\"cookies-info\" ng-if=\"!cokiesInfoShowed\">\n  <p>{{ \"COOKIES_INFO\" | translate }} </p>\n  <button type=\"button\" class=\"md-button md-raised md-primary\" ng-click=\"closeCookiesInfo()\">{{ \"COMMONS.OK\" | translate }}</button>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/users/users.html
// module id = 103
// module chunks = 0